<template>
  <div data-v-6ebeef4c>
    <usertop></usertop>
    <div data-v-6ebeef4c="">
      <div data-v-6ebeef4c="" class="el-col el-col-24 el-col-md-12">
        <div data-v-6ebeef4c="" class="el-card is-never-shadow" style="width: 100%;">
          <div class="el-card__body" style="margin: 0px; padding: 0px; height: 260px; text-align: left;">
            <div data-v-6ebeef4c="" class="G-Title">
              {{user.username}}，欢迎登录
            </div>
            <div data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">积分：</span> <span
                data-v-6ebeef4c="">{{user.price}}</span></div>
            <div v-if="user.gra==0" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">会员等级：</span> <span data-v-6ebeef4c=""
                style="color: rgb(255, 51, 153); font-weight: 800;">普通会员</span>
            </div>
            <div v-if="user.gra==6" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">会员等级：</span> <span data-v-6ebeef4c=""
                style="color: rgb(255, 51, 153); font-weight: 800;">季度会员</span>
            </div>
            <div v-if="user.gra==7" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">会员等级：</span> <span data-v-6ebeef4c=""
                style="color: rgb(255, 51, 153); font-weight: 800;">年度会员</span>
            </div>
            <div v-if="user.gra==8" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">会员等级：</span> <span data-v-6ebeef4c=""
                style="color: rgb(255, 51, 153); font-weight: 800;">永久会员</span>
            </div>
            <div v-if="user.gra==5" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">会员等级：</span> <span data-v-6ebeef4c=""
                style="color: rgb(255, 51, 153); font-weight: 800;">月度会员</span>
            </div>
            <div v-if="user.gra==9" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">会员等级：</span> <span data-v-6ebeef4c=""
                style="color: rgb(255, 51, 153); font-weight: 800;">体验会员</span>
            </div>
            <div v-if="user.gra==99" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">会员等级：</span> <span data-v-6ebeef4c=""
                style="color: rgb(255, 51, 153); font-weight: 800;">管理员</span>
            </div>
            <div v-if="user.term==0" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">会员有效期：</span> <span
                data-v-6ebeef4c="">-</span></div>
            <div v-if="user.term!=0" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">会员有效期：</span> <span
                data-v-6ebeef4c="">{{user.term}}</span></div>
            <div v-if="user.yifa_weitongguo===0" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">待审核信息：</span> <span
                data-v-6ebeef4c="">0</span></div>
            <div v-if="user.yifa_weitongguo!=0" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">待审核信息：</span> <span
                data-v-6ebeef4c="">{{user.yifa_weitongguo}}</span></div>
            <div v-if="user.yifa==0" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">已发布信息：</span> <span
                data-v-6ebeef4c="">0</span></div>
            <div v-if="user.yifa!=0" data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">已发布信息：</span> <span
                data-v-6ebeef4c="">{{user.yifa}}</span></div>
            <div data-v-6ebeef4c="" class="Profile"><span data-v-6ebeef4c="">已拒绝信息：</span> <span
                data-v-6ebeef4c="">0</span></div>
          </div>
        </div>
      </div>
      <div data-v-6ebeef4c="" class="el-col el-col-24 el-col-md-12">
        <div data-v-6ebeef4c="" class="el-card is-never-shadow" style="width: 100%;">
          <div class="el-card__body" style="margin: 0px; padding: 0px; height: 260px; text-align: left;">
            <div data-v-6ebeef4c="" class="userbtn"><a data-v-6ebeef4c="" href="/publish" class="" tags="div"
                style="padding-right: 20px;"><button data-v-6ebeef4c="" type="button"
                  class="el-button el-button--default el-button--small is-plain"><span><span data-v-6ebeef4c=""
                      style="font-size: 14px;">发布赚积分</span></span></button></a> <a data-v-6ebeef4c="" href="/upgrade"
                class="" tags="div"><button data-v-6ebeef4c="" type="button"
                  class="el-button el-button--default el-button--small is-plain"><span><span data-v-6ebeef4c=""
                      style="font-size: 14px;">购买/兑换VIP</span></span></button></a></div>
            <div data-v-6ebeef4c="">
              <div data-v-6ebeef4c=""
                class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
                style="width: 90%; margin: auto;">
                <div class="hidden-columns">
                  <div data-v-6ebeef4c=""></div>
                  <div data-v-6ebeef4c=""></div>
                  <div data-v-6ebeef4c=""></div>
                  <div data-v-6ebeef4c=""></div>
                </div>
                <div class="el-table__header-wrapper">
                  <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 503px;">
                    <colgroup>
                      <col name="el-table_1_column_1" width="128">
                      <col name="el-table_1_column_2" width="125">
                      <col name="el-table_1_column_3" width="125">
                      <col name="el-table_1_column_4" width="125">
                      <col name="gutter" width="0">
                    </colgroup>
                    <thead class="has-gutter">
                      <tr class="">
                        <th colspan="1" rowspan="1" class="el-table_1_column_1     is-leaf">
                          <div class="cell">类型</div>
                        </th>
                        <th colspan="1" rowspan="1" class="el-table_1_column_2     is-leaf">
                          <div class="cell">价格</div>
                        </th>
                        <th colspan="1" rowspan="1" class="el-table_1_column_3     is-leaf">
                          <div class="cell">查看内容</div>
                        </th>
                        <th colspan="1" rowspan="1" class="el-table_1_column_4     is-leaf">
                          <div class="cell">有效期</div>
                        </th>
                        <th class="gutter" style="width: 0px; display: none;"></th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div class="el-table__body-wrapper is-scrolling-none">
                  <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 503px;">
                    <colgroup>
                      <col name="el-table_1_column_1" width="128">
                      <col name="el-table_1_column_2" width="125">
                      <col name="el-table_1_column_3" width="125">
                      <col name="el-table_1_column_4" width="125">
                    </colgroup>
                    <tbody>
                      <tr v-for="u in vips" class="el-table__row">
                        <td rowspan="1" colspan="1" class="el-table_1_column_1  ">
                          <div class="cell">{{u.type}}</div>
                        </td>
                        <td rowspan="1" colspan="1" class="el-table_1_column_2  ">
                          <div class="cell">{{u.price}}</div>
                        </td>
                        <td rowspan="1" colspan="1" class="el-table_1_column_3  ">
                          <div class="cell">Yes</div>
                        </td>
                        <td rowspan="1" colspan="1" class="el-table_1_column_4  ">
                          <div class="cell">{{u.date}}</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="el-table__column-resize-proxy" style="display: none;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'usercenter',
  data() {
    return {

      user:[],

      vips:[],

    }
  },
  methods: {
  },
  mounted() {

    this.$http.post('/api/userinfo',{action:1}).then(res=>{

      this.user = res.data

      this.vips = res.data.uservip

    })

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/usercenter.vue